import React from "react";
import style from "../../RulesSetting/index.module.scss";
import { Button, Icon } from "antd";
import CourseListModal from "../CourseListModal";
import useModalHandler from "utils/useModalHandler";
import CourseRulesForStudentModal from "../CourseRulesForStudentModal";

interface SaveToolsProps {
    gradeWeight: { finalGrade: number; dailyGrade: number };
    onOk: () => void;
    loading: boolean;
    id?: number;
    courseNo: string;
    courseSeq: string;
    onPrev: () => void;
}

const Index = ({
    gradeWeight,
    onOk,
    loading,
    id,
    courseNo,
    onPrev,
    courseSeq
}: SaveToolsProps) => {
    function isPass() {
        const count = gradeWeight.finalGrade + gradeWeight.dailyGrade;
        if (count === 0 || count === 100) {
            return true;
        }
        return false;
    }
    const modal = useModalHandler();
    const preview = useModalHandler();

    async function prevClick() {
        await onPrev();
        await preview.open();
    }
    return (
        <div className={style.footer}>
            <div className={style.description}>
                <Icon type="exclamation-circle" />
                总成绩 = 平时成绩 + 期末成绩 当前合计
                <strong className={isPass() ? style.success : style.error}>
                    {gradeWeight.finalGrade + gradeWeight.dailyGrade}%
                </strong>
            </div>
            <div>
                <Button type="primary" onClick={prevClick} ghost>
                    预览
                </Button>
                <Button type="primary" onClick={onOk} loading={loading}>
                    保存
                </Button>
                {!!id && (
                    <Button type="primary" ghost onClick={modal.open}>
                        应用到其他课程
                    </Button>
                )}
            </div>

            {modal.render(
                <CourseListModal
                    visible={modal.visible}
                    onCancel={modal.close}
                    ruleId={id}
                />
            )}

            {preview.render(
                <CourseRulesForStudentModal
                    visible
                    courseNo={courseNo}
                    courseSeq={courseSeq}
                />
            )}
        </div>
    );
};

export default Index;
